"use strict";

require('../css/webinterface.css');
require('roboto-fontface');
require('font-awesome/css/font-awesome.css');
require('@webhare-wrd/auth');

import * as dompack from 'dompack';
window.$d = dompack;

const IndyShell = require('@__webhareroot-tollium/web/ui/js/shell');
const docs = require('../pages/docs/docs.js');
const sites = require('../pages/sites/sites.js');

if(document.documentElement.classList.contains('wh-tollium--app'))
{
  if(!document.all && ("max" in document.createElement("progress")) && !document.documentElement.hasClass("previewframe")) //IE < 11
  {
    window.$shell = new IndyShell;
  }
}
else if(document.documentElement.classList.contains('wh-tollium--docs'))
{
  dompack.onDomReady(docs.onReady);
}
else if(document.documentElement.classList.contains('wh-tollium--sites'))
{
  dompack.onDomReady(sites.onReady);
}
else if(window.parent && document.documentElement.hasClass("previewframe")) //plain preview interface
{
  if(window.parent.suggestRenderingPDF)
  {
    let whpdfnode = document.querySelector('wh-pdf');
    if(whpdfnode)
      window.parent.suggestRenderingPDF(whpdfnode.getAttribute("url"));
  }
}



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/webdesigns/webinterface/js/webinterface.es